/**
 * A single weight bracket row while it is being edited in the inline table. `bracket` is nullable
 * here (an empty number input maps to `null`) even though the persisted DTO requires a number — the
 * table narrows it before the value is sent to the gateway. `id` is a UI-only key that keeps React
 * focus on the right input as rows re-sort; it is never persisted.
 */
export type BracketConfigDraft = {
  id?: string;
  bracket: number | null;
  cubicAllowance: number | null;
};

let bracketDraftSeq = 0;

/**
 * Builds a draft row with a stable id. Use this instead of an object literal so re-sorting rows
 * keeps each input tied to its row (stable React key). The id is UI-only and stripped on save.
 */
export function createBracketDraft(
  values: Pick<BracketConfigDraft, 'bracket' | 'cubicAllowance'> = {
    bracket: null,
    cubicAllowance: null,
  },
): BracketConfigDraft {
  bracketDraftSeq += 1;
  return {
    id: `bracket-${bracketDraftSeq}`,
    bracket: values.bracket,
    cubicAllowance: values.cubicAllowance,
  };
}
